import classNames from 'classnames';
import { IGoal } from 'motw_core/Entity/IGoal';
import * as React from 'react';
import { GoalEditor } from 'source/app/presentation/MainPanel/Goals/GoalEditor/GoalEditor';
import Hyperlink from 'source/app/presentation/Shared/Link/Hyperlink';
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';

export function GoalCardsIcon({ goal }: { goal: IGoal }) {
	const goalIconStyleClass = StyleClass(`goalIcon`, {
		fontSize: '30px',
		position: 'relative',
		bottom: '9px'
	});

	const archivedGoalIconStyleClass = StyleClass(`archivedGoalIcon`, {
		color: `gray`
	});

	return (
		<Hyperlink id="goalIcon" whenClicked={() => GoalEditor(goal)}>
			<div
				id="goalIcon"
				className={classNames(
					goalIconStyleClass,
					`ra ra-${goal.icon}`,
					{
						[archivedGoalIconStyleClass]: goal.name[0] === '_'
					}
				)}
			/>
		</Hyperlink>
	);
}
